var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMsqToken = function SvgMsqToken(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62009 0.363868C6.1172 -0.121289 5.30155 -0.121289 4.79841 0.363868C4.29527 0.849025 4.29527 1.63528 4.79841 2.12044L8.24444 5.4433L9.05463 4.66207C9.61337 4.12354 9.61337 3.24992 9.05463 2.71115L6.62009 0.363868Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49912 1.85567L10.2316 8.44932L8.37457 10.268L1.64211 3.67439L3.49912 1.85567Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5016 6.5567L6.94937 9.81192C7.45197 10.3126 7.45197 11.1241 6.94937 11.6245C6.44702 12.1252 5.63225 12.1252 5.12965 11.6245L2.69229 9.17051C2.13415 8.61456 2.13415 7.91881 2.69229 7.36285L3.5016 6.5567Z",
    fill: "currentcolor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6301 4.95242C11.1365 4.45229 10.3369 4.45229 9.84354 4.95242C9.3504 5.45281 9.3504 6.26374 9.84354 6.76413L10.7368 7.6701L11.6301 6.76413C12.1233 6.26374 12.1233 5.45281 11.6301 4.95242Z",
    fill: "currentcolor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.26319 4.3299L2.15627 5.23564C2.64966 5.73604 2.64966 6.54699 2.15627 7.04738C1.66311 7.54778 0.863262 7.54778 0.369865 7.04738C-0.123288 6.54699 -0.123288 5.73604 0.369865 5.23564L1.26319 4.3299Z",
    fill: "currentcolor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMsqToken);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/msq-token.e4318f09bf8a931f24724195c7283d08.svg";